// Copyright (c) StrangeBee 2023

import { Route as RouteAccount } from './Details';

export const Routes = [RouteAccount];
